// extracted by mini-css-extract-plugin
export var Collapse = "styles-module--Collapse--60c9b";
export var MainFacetLabel = "styles-module--MainFacetLabel--73064";
export var hamburger = "styles-module--hamburger--4b660";
export var homeLink = "styles-module--homeLink--b5bba";
export var legacy = "styles-module--legacy--9552c";
export var mainLogo = "styles-module--mainLogo--d841d";
export var mainSelector_wrap = "styles-module--mainSelector_wrap--a6b88";
export var mobileIndicator = "styles-module--mobile-indicator--43ce4";
export var sidebar = "styles-module--sidebar--a0958";
export var topicLabel = "styles-module--topicLabel--2dcf5";